<template>
	<el-input
		type="number"
		class="number-input"
		:value="value"
		:min="min"
		v-bind="$attrs"
		v-on="{ ...$listeners, input: handleInput }"
		@mousewheel.native.prevent
		@DOMMouseScroll.native.prevent
	>
		<template v-for="(index, name) in $slots" :slot="name">
			<slot :name="name"></slot>
		</template>
	</el-input>
</template>

<script>
/**
 * 数字输入框组件
 * @param {Number | String} value - 输入框值
 * @param {Number} precision - 小数点位数
 * @param {Number} min - 最小值
 * @event change - 输入框值改变事件
 * @event clear - 清空事件
 */
export default {
	name: "NumberInput",
	inheritAttrs: false,
	props: {
		value: {
			type: [Number, String, null],
			default: ""
		},
		precision: {
			type: Number,
			default: 2
		},
		min: {
			type: Number,
			default: 0
		}
	},
	methods: {
		handleInput(val) {
			const regex = (!this.min && this.min !== 0) || this.min < 0 ? /^-?(?!0\d)\d*\.?\d+$/ : /^(?!0\d)\d*\.?\d+$/;

			if (val) {
				if (regex.test(val)) {
					const valArr = val.split(".");

					if (valArr[1] && valArr[1].length > this.precision) {
						return;
					}

					if ((this.min || this.min === 0) && val < this.min) {
						return;
					}

					if ((this.$attrs.max || this.$attrs.max === 0) && val > this.$attrs.max) {
						return;
					}

					this.$emit("input", val);
				}
			} else {
				this.$emit("input", val);
			}
		}
	}
};
</script>

<style lang="scss">
.number-input {
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
		appearance: textfield;
	}
}
</style>
